// File: /src/components/ImageCarousel/ImageCarouselElements.js

import styled from "styled-components";

export const CarouselContainer = styled.div`
    max-width: 1100px;
    max-height: 700px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
`;

export const CarouselImg = styled.img`
    max-height: 700px;
    height: auto;
    max-width: 1100px;
`;